import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";

/**
 * Component for the final Review/Order Complete step.
 * Displays a success message and the order number.
 * @param {object} props - Component props
 * @param {string | null} props.orderNumber - The order number to display.
 */
const ReviewStep = ({ orderNumber }) => {
  const { t } = useTranslation();
  const { t: tCheckout } = useTranslation("checkout");

  return (
    <Box sx={{ p: 3, textAlign: "center" }}>
      <CheckCircleIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        {tCheckout("orderPlacedSuccessfully")}
      </Typography>
      {orderNumber ? (
        <Typography variant="body1" color="text.secondary">
          {tCheckout("thankYouWithOrderNumber", { orderNumber: orderNumber })}
        </Typography>
      ) : (
        <Typography variant="body1" color="text.secondary">
          {tCheckout("thankYouGeneric")}
        </Typography>
      )}
      {/* Optional: Add link to view order details or continue shopping */}
      {/* <Button variant="contained" sx={{ mt: 3 }} onClick={() => navigate('/orders')}>View My Orders</Button> */}
    </Box>
  );
};

export default ReviewStep;
